module.exports = __webpack_public_path__ + "img/logo2.6af758fe.png";